import { useState } from 'react';
import { Link } from 'react-router-dom';
import company from '@/content/company.json';
import { useI18n } from '@/lib/i18n';
import './MapEmbed.css';

/**
 * Google Maps, loaded only after a click: the iframe sends the visitor's IP
 * to Google and may set cookies, which needs consent first (GDPR, § 165 TKG
 * 2021 — see PrivacyPage). The consent is per page view, never stored.
 */
// The Softmaze Google Business listing (Maps "cid"). Linking the listing
// rather than the street address opens the business card (name, hours,
// route) instead of a bare address pin shared with the shop downstairs.
const LISTING_CID = '8374713980267950454';

export default function MapEmbed() {
    const { section, to } = useI18n();
    const c = section('contact.map') as Record<string, string>;
    const [loaded, setLoaded] = useState(false);

    if (loaded) {
        return (
            <iframe
                className="map-embed"
                title={c.title}
                src={`https://www.google.com/maps?cid=${LISTING_CID}&output=embed`}
                referrerPolicy="no-referrer-when-downgrade"
            />
        );
    }

    return (
        <div className="map-consent">
            <p className="map-consent__address">{company.address}</p>
            <button type="button" className="btn btn--primary btn--sm" onClick={() => setLoaded(true)}>
                {c.load}
            </button>
            <p className="map-consent__note">
                {c.note} <Link to={to('/privacy')}>{c.privacy}</Link>
            </p>
            <a
                className="map-consent__open mono"
                href={`https://www.google.com/maps?cid=${LISTING_CID}`}
                target="_blank"
                rel="noopener noreferrer"
            >
                {c.open} ↗
            </a>
        </div>
    );
}
